export default __webpack_public_path__ + "static/media/incoming_call.d9c3fe04.wav";